module.exports = __webpack_public_path__ + "img/image334.431c6d4c.png";